import React from 'react';
import { SvgIconWrapProps } from '../';
import { StyledIconWrap } from './styled';
import { Box } from '@mui/material';

export const SvgIconWrap = (props: SvgIconWrapProps) => (
  <StyledIconWrap
    {...props}
    // component={'div'}
    width={props.width}
    height={props.height}
    radius={props.radius}
    color={props.color as string}
    bgcolor={props.bgcolor}
    hover={!!props.hover}
    hoverColor={props.hoverColor}
    sx={{
      backgroundColor: props.color
    }}
  >
    <Box
      color={props.iconColor}
      sx={{
        display: `inline-flex`,
        alignItems: `center`,
        justifyContent: `center`
      }}
    >
      {props.children}
    </Box>
  </StyledIconWrap>
);
